<template>
  <HomeView v-if="isStaffOrAccountHost" />
  <AttorneySignupView v-else />
</template>

<script setup>
import HomeView from './HomeView.vue';
import AttorneySignupView from './AttorneySignupView.vue';

const isStaffOrAccountHost = ['admin.lomaxlawconnect.com', 'llfconnect-admin.web.app', 'llfconnect-admin.firebaseapp.com', 'account.askmaix.com'].includes(window.location.hostname);
</script>
